import { useState } from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export const TEXTO_DEL_AVISO_DE_AUSENCIA =
  "Según terreno, no está en el predio. Revise la explicación del encargado y decida si queda en el informe.";

interface AvisoDeAusenciaEnTerrenoProps {
  /** Cómo se llama la fila en el diálogo: "máquina", "instalación". */
  queEs: string;
  /** "Quitar esta máquina del informe": concuerda con el género de `queEs`. */
  esta: "esta" | "este";
  nombre: string;
  /** Cuántas fotos se van con la fila si se quita. */
  fotos: number;
  ocupada: boolean;
  onQuitar: () => void;
  onMantener: () => void;
}

/**
 * El aviso de la fila expandida cuando el encargado dijo que ya no está en el
 * predio: la web NO decide sola, le pregunta a quien redacta.
 *
 * «Quitar de la lista» borra la fila y se lleva sus fotos, y no se deshace:
 * por eso pregunta antes, con el mismo texto que el diálogo de la fila. «Mantener»
 * deja la fila y queda registrado (el servidor guarda cuándo) para no volver a
 * preguntar hasta que terreno observe la ausencia de nuevo.
 */
export function AvisoDeAusenciaEnTerreno({
  queEs,
  esta,
  nombre,
  fotos,
  ocupada,
  onQuitar,
  onMantener,
}: AvisoDeAusenciaEnTerrenoProps) {
  const [confirmando, setConfirmando] = useState(false);

  return (
    <div
      role="note"
      className="bg-danger-soft border-danger-dot/40 mx-5 mb-2 flex flex-wrap items-center gap-3 rounded-lg border px-3.5 py-2.5"
    >
      <p className="text-danger-soft-foreground min-w-[16rem] flex-1 text-xs font-semibold text-pretty">
        {TEXTO_DEL_AVISO_DE_AUSENCIA}
      </p>
      <div className="flex flex-none gap-2">
        <Button
          type="button"
          size="sm"
          variant="destructive"
          disabled={ocupada}
          onClick={() => setConfirmando(true)}
        >
          Quitar de la lista
        </Button>
        <Button type="button" size="sm" variant="outline" disabled={ocupada} onClick={onMantener}>
          Mantener
        </Button>
      </div>

      {/* QUITAR SE LLEVA LAS FOTOS Y NO SE DESHACE, así que se pregunta: el
          mismo criterio y las mismas palabras que el diálogo de la fila. */}
      <AlertDialog open={confirmando} onOpenChange={setConfirmando}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>¿Quitar {esta} {queEs} del informe?</AlertDialogTitle>
            <AlertDialogDescription>
              Se va “{nombre}” junto con {fotos === 1 ? "su foto" : `sus ${fotos} fotos`}. No se
              puede deshacer.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                setConfirmando(false);
                onQuitar();
              }}
            >
              Quitar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
